export enum Ui89Theme {
  primary = "primary",
  secondary = "secondary",
  info = "info",
  success = "success",
  warning = "warning",
  danger = "danger",
}

export enum Ui89Palette {
  black = "black",
  darkBlue = "darkBlue",
  darkGreen = "darkGreen",
  darkCyan = "darkCyan",
  darkRed = "darkRed",
  darkPink = "darkPink",
  darkYellow = "darkYellow",
  lightGray = "lightGray",
  darkGray = "darkGray",
  lightBlue = "lightBlue",
  lightGreen = "lightGreen",
  lightCyan = "lightCyan",
  lightRed = "lightRed",
  lightPink = "lightPink",
  lightYellow = "lightYellow",
  white = "white",
}
